import React from "react";
import { Link } from "react-router-dom";
import { barFunFinderGradient } from "../../styles/gradient";
import { useActiveBar } from "../ActiveBarContext";

// Charity "Boost & Pro" page.
// Charities don't buy Pro — Pro belongs to the bar. Charities can boost
// their own events ($10 each) so more people see raffles, bingo, etc.
export default function Subscription() {
  const { myBars } = useActiveBar();

  const card = {
    background: "rgba(255,255,255,0.05)",
    padding: "20px",
    borderRadius: "12px",
    maxWidth: "640px",
    marginBottom: "20px",
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "var(--dark-bg)",
        backgroundImage: barFunFinderGradient,
        color: "#fff",
        fontFamily: "Inter",
        padding: "30px",
      }}
    >
      <h1 style={{ marginBottom: "8px" }}>Boost &amp; Pro</h1>
      <p style={{ marginBottom: "24px", opacity: 0.8, maxWidth: "640px", lineHeight: 1.5 }}>
        Your charity account is free during our launch. You don't pay to post
        events or keep your gaming info up to date.
      </p>

      <div style={card}>
        <h2 style={{ fontSize: "20px", margin: "0 0 8px" }}>Boost an event — $10</h2>
        <p style={{ margin: "0 0 14px", lineHeight: 1.5, opacity: 0.85 }}>
          Want a big crowd for a meat raffle or bingo night? A boost puts that
          event at the top of the Home screen with a "Featured" badge for
          everyone nearby, on the day it happens. One-time $10, no subscription.
        </p>
        <Link
          to="/charity/events"
          style={{
            display: "inline-block",
            padding: "12px 18px",
            borderRadius: "10px",
            background: "#FF3D81",
            color: "#0B0B12",
            fontWeight: 700,
            textDecoration: "none",
          }}
        >
          Go to my events to boost one
        </Link>
      </div>

      <div style={card}>
        <h2 style={{ fontSize: "20px", margin: "0 0 8px" }}>Your bars and Pro</h2>
        <p style={{ margin: "0 0 14px", lineHeight: 1.5, opacity: 0.85 }}>
          Pro ($39/month) is paid by the bar owner. It shows the bar first to
          customers nearby. If a bar you work with is on Pro, your events there
          get seen more too.
        </p>
        {myBars.length === 0 ? (
          <p style={{ opacity: 0.8 }}>
            No bars linked yet. <Link to="/charity/claim-bar" style={{ color: "#FF6FA3" }}>Link a bar</Link>
          </p>
        ) : (
          <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
            {myBars.map((b) => (
              <li
                key={b.id}
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  gap: "12px",
                  padding: "10px 0",
                  borderTop: "1px solid rgba(255,255,255,0.08)",
                }}
              >
                <span>{b.name || "Unnamed bar"}</span>
                {b.featured ? (
                  <span style={{ color: "#4ade80" }}>✓ On Pro (paid by the bar)</span>
                ) : (
                  <span style={{ opacity: 0.6 }}>Free plan</span>
                )}
              </li>
            ))}
          </ul>
        )}
        <p style={{ margin: "14px 0 0", fontSize: "14px", opacity: 0.6 }}>
          Think a bar would benefit from Pro? Let the owner know they can turn
          it on under Promote → Get featured in their dashboard.
        </p>
      </div>
    </div>
  );
}
